import {
    Grid,
    Typography,
    WithStyles,
    withStyles,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles/filterDialog";
import { MyPATDialog, MyPATSearchBar } from "../../common";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PerfectScrollbar from 'react-perfect-scrollbar';


interface FilterDialogProps extends WithStyles<typeof userStyles> {
    children: any,
    index: any,
    value: any
}

class FilterDialog extends Component<FilterDialogProps> {
    constructor(props: FilterDialogProps) {
        super(props);
    }

    renderClientList = () => {
        const { classes } = this.props;
        return (<>
            <Grid className="searchBar">
                <MyPATSearchBar />
            </Grid>

            {/* @Frontend Dev: Just repeat the list for Iterate the data */}
            <Grid className="list">
                <FormGroup>
                    <FormControlLabel
                        control={<Checkbox
                            classes={{
                                root: classes.checkBoxElement,
                                checked: classes.checkedCheckbox,
                                colorPrimary: classes.primaryColor
                            }}
                            color="primary"
                        //checked={} 
                        />}
                        classes={{ label: classes.checkboxLabel, root: classes.marginBottomSM }}
                        label="Fittjee GWALIOR"
                    />
                </FormGroup>
            </Grid>
        </>)
    }

    render() {
        const { children, value, classes, ...other } = this.props;

        return (
            <MyPATDialog
                dialogOpen={false}
                dialogHasActions={true}
                dialogHeading={
                    <Typography className={classes.dialogTitle}>
                        Add Filter
              </Typography>
                }
                isAlignCenter={false}
                variantHeader="leftHeader"
                customButtonVariant="withoutBorderCloseIcon"
                isCustomBackground={false}
                isborderDialogAction={false}
                otherDialogProps={{
                    fullWidth: false,
                }}
                customDialogActions={
                    <>
                        <Grid container justify="space-between" alignItems="center">
                            <Grid item>
                                <span>
                                    2 Filter Selected
                          </span>
                            </Grid>
                            <Grid item>
                                <Button color="primary">
                                    Reset
                      </Button>
                                <Button variant="contained" color="primary">Apply</Button>
                            </Grid>
                        </Grid>
                    </>
                }
            >

                <Grid container justify="space-between" className={classes.dialogContainer}>
                    <Grid item>
                        <Grid className="leftBox">
                            <PerfectScrollbar>
                                <Grid container className={[classes.activeLink, "listItem"].join(' ')} justify="space-between" alignItems="center">
                                    <Grid item>
                                        <Typography variant="body1">Client (200)</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Grid>
                                            <ChevronRightIcon />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container className="listItem" justify="space-between" alignItems="center">
                                    <Grid item>
                                        <Typography variant="body1">Role Type (200)</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Grid>
                                            <ChevronRightIcon />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container className="listItem" justify="space-between" alignItems="center">
                                    <Grid item>
                                        <Typography variant="body1">Role Type (200)</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Grid>
                                            <ChevronRightIcon />
                                        </Grid>
                                    </Grid>
                                </Grid>


                            </PerfectScrollbar>
                        </Grid>
                    </Grid>


                    <Grid item>
                        <Grid className={classes.rightBox}>
                            <PerfectScrollbar>
                                {this.renderClientList()}
                            </PerfectScrollbar>
                        </Grid>
                    </Grid>
                </Grid>

            </MyPATDialog>
        );
    }
}

// @ts-ignore
export default connect()(withStyles(userStyles)(FilterDialog));
